module.exports = __webpack_public_path__ + "img/tarjeta-visita-2.cb558299.png";